export default {
  "dashboard.title": "興行収入レポート",
}